import { useRoles } from 'domains/Auth/authSlice/useRoles';
import { PathsType } from '../types';

const settingOptionByRole: Record<string, PathsType> = {
  payments: 'payments',
  shipping: 'shipping',
  locations: 'locations',
  emails: 'emails',
  preferences_checkout: 'checkoutOptions',
  preferences_advanced: 'externalCodes',
  domains: 'domains',
  i18n: 'i18n',
  seo_redirects: 'redirects301',
  products: 'metafields',
  orders: 'metafields',
  customers: 'metafields',
};

export function useGetDefaultSettingsOption(): PathsType {
  const { validateRoles } = useRoles();

  const option = Object.entries(settingOptionByRole).find(([role]) =>
    validateRoles(role),
  );

  return option?.[1] ?? 'locations';
}
